import { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { useSelector } from "react-redux";
import ReactPlayer from 'react-player';
import { useHistory } from 'react-router-dom';
import { MEDIA_ORIGIN } from "../../utils/Environment";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getBannerDetails } from "../../lib/api";
import LoadingSpinner from "../UI/LoadingSpinner";

const Banner = () => {

  const history = useHistory();
  const { currentUser } = useSelector((state) => state.user);
  const [bannerData, setBannerData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [showIndicators, setShowIndicators] = useState(true);
  
  const sendBannerRequest = (currentUser) => {
    setIsLoading(true)
    getBannerDetails(currentUser)
      .then((response) => {
        setBannerData(response);
        setIsLoading(false);
        if(currentUser === null || response.length === 1) {
          setShowIndicators(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false)
      });
  };

  useEffect(() => {
    sendBannerRequest(currentUser);
  }, [currentUser]);

  const onChangec = (index, items) => {
  };

  const onClickItemc = (index) => {
    if (index === 0 && currentUser === null) {
      history.push('/register');
    }    
  };

  const onClickThumbc = () => {
  };

  const buttonLinkOne = (redirect_links) => {
    var split_link = redirect_links.split(",");
    if(split_link[0]) {
      var first_link = split_link[0].split("@");
      return "<a href='"+first_link[0]+"' target='_blank'>"+first_link[1]+"</a>";      
    }        
  };

  const buttonLinkTwo = (redirect_links) => {
    var split_link = redirect_links.split(",");
    if(split_link[1]) {
      var second_link = split_link[1].split("@");
      return "<a href='"+second_link[0]+"' target='_blank'>"+second_link[1]+"</a>";      
    }        
  };  

  return (
    <section className="videoBanner relative">
      {isLoading && (
        <div className="parentDisable">
          <LoadingSpinner />
        </div>
      )}
      <div className="videosHolder bg-[#006FBA]  w-full">
        {bannerData && bannerData.length > 0 ? (
          <Carousel
            key={bannerData.length}
            showArrows={false}
            showThumbs={false}
            onChange={onChangec}
            onClickItem={onClickItemc}
            onClickThumb={onClickThumbc}
            autoPlay={true}
            interval={3000}
            infiniteLoop={true}
            stopOnHover={true}
            showIndicators={showIndicators}
            showStatus={false}
          >
            {bannerData.map((details, key) =>
              details.banner_asset.split(".").pop() === "mp4" ? (
                <div key={details.uuid} className={'videoOverlay'}>
                  <ReactPlayer key={key} className="!size-full" url={`${MEDIA_ORIGIN}${details.banner_asset}`} loop={true} playing controls={false} muted onContextMenu={e => e.preventDefault()} playsinline/>
                </div>
              ) : (
                <div key={details.uuid} className="imageOverlay">
                  <img alt="" src={`${MEDIA_ORIGIN}${details.banner_asset}`}/>
                  <div className="overlayContent absolute top-0 bottom-0 h-full flex justify-center px-5 lg:px-[56px] max-w-full sm:max-w-[85%] md:max-w-[65%] lg:max-w-[60%] xl:max-w-[45%]">
                    <div className="flex flex-col gap-3 sm:gap-4 h-full justify-center">
                      <h1 className="welcomeText text-2xl leading-6 sm:text-[40px] font-bold sm:leading-[48px] text-white text-left">{details.title}</h1>
                      <p className="text-[#E4ECF2] text-base leading-6 sm:text-[28px] font-normal sm:leading-10 tracking-[0.1px] text-left">{details.description}</p>
                      <div className="flex  gap-4">
                        <span dangerouslySetInnerHTML={{ __html: buttonLinkOne(details.redirect_links) }} className="btn !w-auto !min-w-fit browseCourses bg-primaryBlue text-white rounded px-[10px] py-1 sm:px-4 sm:py-[10px] text-sm font-bold leading-5 sm:text-base sm:leading-5  cursor-pointer mr-auto" target="_blank" rel="noreferrer"></span>                                                                  
                        <span dangerouslySetInnerHTML={{ __html: buttonLinkTwo(details.redirect_links) }} className="btn !w-auto !min-w-fit browseCourses bg-primaryBlue text-white rounded px-[10px] py-1 sm:px-4 sm:py-[10px] text-sm font-bold leading-5 sm:text-base sm:leading-5  cursor-pointer mr-auto" target="_blank" rel="noreferrer"></span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </Carousel>
        ) : (
          <span></span>
        )}
      </div>
    </section>
  )
}

export default Banner